import React from 'react'
import {Icon} from "../../constants/consts-types"
import Svg from "../Svg/Svg"
import LinkDuo from "../LinkDuo/LinkDuo"

const SubBrandLogo = props => {
  const {subBrand, url} = props

  if(url) {
    return (
      <LinkDuo to={url} aria-label={subBrand}>
        <Svg id={Icon[subBrand]}/>
      </LinkDuo>
    )
  } else {
    return <Svg id={Icon[subBrand]}/>
  }
}

export default SubBrandLogo



// WEBPACK FOOTER //
// ./src/components/SubBrandLogo/SubBrandLogo.js